<template>
  <div class="field-boolean-edit position-relative">
  
    <!-- Botón de lock/unlock para campos safe (solo si no está deshabilitado) -->
    <div v-if="field.safe && !disableLock" class="float-left">
      <button
        v-if="isLocked"
        type="button"
        class="btn btn-sm btn-outline-secondary border-0 buttonn-lock"
        @click="unlockField"
      >
        <i class="material-icons">lock</i>
      </button>
      <button
        v-else
        type="button"
        class="btn btn-outline-primary btn-sm border-0 buttonn-lock"
        @click="lockField"
      >
        <i class="material-icons">lock_open</i>
      </button>
    </div>

    <div class="form-check form-switch">
      <input
        type="checkbox"
        :checked="displayValue === true"
        :id="computedFieldId"
        class="form-check-input"
        :class="{
          // Azul del sistema solo tildado: fijo, el «NO» también se veía prendido (#493).
          'bg-primary border-primary': displayValue === true,
          'calculated-field': isLocked,
          'readonly-field': calculated || field.readonly,
        }"
        :disabled="field.readonly || isLocked"
        @change="onFieldChange($event.target.checked)"
        @blur="onBlur"
        @focus="onFocus"
      />
      <label :for="computedFieldId" class="form-check-label">
        {{ displayValue === true ? "YES" : "NO" }}
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: "EditFieldBoolean",
  props: {
    field: {
      type: Object,
      required: true,
    },
    value: {
      // String antes que Boolean: si no, Vue convierte el "" de un formulario nuevo en
      // `true` y el campo se ve en «YES» aunque se guarde vacío (#493, duntower).
      type: [String, Boolean, Array],
      default: null,
    },
    fieldId: {
      type: String,
      default: null,
    },
    editingFields: {
      type: String,
      default: "",
    },
    disableLock: {
      type: Boolean,
      default: false,
    },
    calculated: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      activelyEditing: false,
    };
  },
  computed: {
    displayValue() {
      if (this.value !== null && this.value !== undefined) {
        return this.value;
      }
      if (this.field.defaultValue !== undefined && this.field.defaultValue !== null) {
        return this.field.defaultValue === true || this.field.defaultValue === "true";
      }
      return false;
    },
    computedFieldId() {
      return this.fieldId || `field-boolean-${this.field.key}`;
    },
    isLocked() {
      if (this.activelyEditing) {
        return false;
      }
      if (this.value === null || this.value === undefined) {
        return false;
      }
      if (this.field.safe && this.editingFields !== this.field.key) {
        return true;
      }
      return false;
    },
  },
  methods: {
    onFieldChange(newValue) {
      this.activelyEditing = true;
      this.$emit("input", newValue);
    },
    onBlur() {
      if (this.field.safe && this.editingFields !== this.field.key) {
        this.activelyEditing = false;
      }
    },
    onFocus() {
      if (this.field.safe && this.editingFields !== this.field.key) {
        this.activelyEditing = true;
      }
    },
    lockField() {
      this.$emit("update:editingFields", "");
      this.activelyEditing = false;
    },
    unlockField() {
      this.$emit("update:editingFields", this.field.key);
      this.activelyEditing = true;
    },
  },
};
</script>

<style scoped>
.field-boolean-edit {
  width: 100%;
}

.calculated-field {
  opacity: 0.6;
  cursor: not-allowed !important;
}
</style>

